import $ from "jquery";
import magnificPopup from "magnific-popup";

export default class {
    constructor( settings = {} ) {
        let that = this;

        that.options = $.extend( {
                popupClose: "Schließen",
                popupEasing: "ease-in-out",
                popupImageError: "<a href=\"%url%\">Das Bild</a> konnte nicht geladen werden.",
                popupLoading: "Wird geladen...",
                titlePrevButton: 'Vorheriges (Linke Pfeiltaste)',
                titleNextButton: 'Nächstes (Rechte Pfeiltaste)',
                textCounter: '<span class="mfp-counter">%curr% von %total%</span>',
                popupImageOpener: "img",
                popupTitleSource: "title",
                popupZoom: true,
                selectors: {
                    openImageLayerButton: ".lightbox",
                    openImageGalleryLayerButton: ".lightbox"
                },
            },
            settings );
    }

    init() {
        let that = this;

        that.addImageLightbox();
        that.addImageLightboxGallery();
        that.addVideoLightbox();
        that.addVideoStreamingLightbox();
    }

    addImageLightbox() {
        let that = this,
            openerElements = $( that.options.selectors.openImageLayerButton );

        if ( openerElements.length === 0 ) {
            return false;
        }

        openerElements
            .magnificPopup( {
                type: "image",
                tClose: that.options.popupClose,
                tLoading: that.options.popupLoading,
                image: {
                    titleSrc: that.options.popupTitleSource,
                    tError: that.options.popupImageError
                },
                zoom: {
                    enabled: that.options.popupZoom,
                    easing: that.options.popupEasing,
                    opener: function( openerElement ) {
                        if ( openerElement.is( that.options.popupImageOpener ) ) {
                            return openerElement;
                        } else {
                            return openerElement.find( that.options.popupImageOpener );
                        }
                    }
                }
            } );
    }

    addImageLightboxGallery() {
        let that = this,
            openerElements = $( that.options.selectors.openImageGalleryLayerButton );

        if ( openerElements.length === 0 ) {
            return false;
        }

        openerElements
            .magnificPopup( {
                type: "image",
                tClose: that.options.popupClose,
                tLoading: that.options.popupLoading,
                image: {
                    titleSrc: that.options.popupTitleSource,
                    tError: that.options.popupImageError
                },
                gallery: {
                    enabled: true,
                    tPrev: that.options.titlePrevButton,
                    tNext: that.options.titleNextButton,
                    tCounter: that.options.textCounter
                },
                zoom: {
                    enabled: that.options.popupZoom,
                    easing: that.options.popupEasing,
                    opener: function( openerElement ) {
                        if ( openerElement.is( that.options.popupImageOpener ) ) {
                            return openerElement;
                        } else {
                            return openerElement.find( that.options.popupImageOpener );
                        }
                    }
                }
            } );
    }
}


// WEBPACK FOOTER //
// ../htdocs/web/typo3conf/ext/vero/Resources/Public/JavaScript/Src/Components/init-magnific-popup.js